class StatusTarefas  {
    #statusPorCodigo = {
        aVencer: "1",
        atrasadas: "5",
        concluidas: "2",
        riscoDeMulta: "6",
        enviadas: "7",
        paralisadas: "8",
        aConferir: "10"
    }
    #statusPorTexto = {
        aVencer: "A fazer",
        atrasadas: "Atrasada",
        concluidas: "Concluído",
        riscoDeMulta: "Risco de multas",
        enviadas: "Enviado",
        paralisadas: "Paralisada",
        aConferir: "A conferir"
    }

    obterTexto(status) {
        return this.#statusPorTexto[status]
    }
    obterCodigo(texto) {
        return this.#statusPorCodigo[texto]
    }
} 

export const statusTarefas = new StatusTarefas()
